// 引入Vue
import Vue from 'vue'
// 引入路由
import VueRouter from 'vue-router'
// 使用插件
Vue.use(VueRouter)

// 创建并暴露一个路由
export default new VueRouter({
  routes:[
    {
      path:'/',
      component: ()=>import("../views/Index.vue"),
      meta:{
        title:"摩斯输入法"
      }
    }
  ]
})